import React from 'react'
import cssModules from 'react-css-modules'
import styles from './cant_chip_in.less'
import { getI18n } from 'client/i18n'
import IconCircle from 'components/common/icon_circle'
import { connect } from 'react-redux'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'

const i18n = getI18n('components/cant_chip_in')

class CantChipIn extends React.Component {
  static propTypes = {
    router: routerShape.isRequired,
  }

  handleClose = () => {
    exitGlimpse('nochipin', this.props.router)
  }

  render() {
    return (
      <div styleName="cant-chip-in">
        <div styleName="icon-container">
          <IconCircle type="rocket" iconSize="big" strokeColor="blue" />
        </div>
        <div styleName="title">{i18n('not_accepting_contributors')}</div>
        <div styleName="description">{i18n('contact_organizer')}</div>
      </div>
    )
  }
}

export default connect()(cssModules(CantChipIn, styles))
